import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import ShowMore from '../../../shared-components/ShowMore/ShowMore';
import seoTrns from '../../home/components/SeoTextContainers/trns';
import TextButton from '../../../shared-components/design-system/TextButton';

interface Props {
  text: string;
  title: string;
}
const ShowMoreSeoText: FC<Props> = ({ title, text }) => {
  const [isTitle, setStatusTitle] = useState(true);
  const [isBlur, setBlur] = useState(true);

  const handlerShowLess = (value) => {
    setStatusTitle(!value);
    setBlur(!value);
  };

  return (
    <div className="px-4 lm:px-0 my-10 lm:mt-0">
      {isTitle && (
        <h2 className="text-astronautBlue text-[28px] leading-6 fs-body-bold">
          {title}
        </h2>
      )}
      <ShowMore
        showLines={6}
        showMore={
          <div className="flex relative w-full justify-center items-center pt-6">
            <div
              className={cn(
                isBlur &&
                  'w-full from-white bg-gradient-to-t from-white h-6 absolute -top-6'
              )}
            >
              <TextButton
                buttonLabel={<FormattedMessage {...seoTrns.showMoreTitle} />}
                className="mx-auto relative bottom-[-40px]"
              />
            </div>
          </div>
        }
        showLess={
          <TextButton
            buttonLabel={<FormattedMessage {...seoTrns.showLessTitle} />}
            className="mx-auto"
          />
        }
        handlerShowLessClick={handlerShowLess}
        isExtendedFunction={true}
      >
        <div
          className="font-light text-gray300 leading-6 compendium-innerHtmlStyling mb-9 compendium-seo-container"
          dangerouslySetInnerHTML={{
            __html: text
          }}
        />
      </ShowMore>
    </div>
  );
};

export default ShowMoreSeoText;
